var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.213 15.692a.43.43 0 0 1-.426 0L1.967 8.06c.564-2.077 2.447-3.615 4.7-3.615h18.666c2.26 0 4.148 1.549 4.706 3.634zm-.211 2.724c.515 0 1.03-.13 1.5-.39l12.72-7.004v11.644a4.893 4.893 0 0 1-4.889 4.89H6.667a4.893 4.893 0 0 1-4.89-4.89V11.002l12.72 7.024c.47.261.99.39 1.505.39",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;